import type { KyInstance } from 'ky'

/**
 * `/check-user` registra l'utente lato API: ky lancia su ogni non-2xx e sugli errori di rete.
 * `onFailure` gira quando ritorna false (main.ts ferma il rinnovo periodico del token: l'app
 * non parte, il timer non deve restare vivo dietro la pagina d'errore).
 */
export async function checkUser(
  api: Pick<KyInstance, 'get'>,
  onFailure?: () => void
): Promise<boolean> {
  let ok = false
  try {
    const response = await api.get('check-user')
    ok = response.ok
  } catch (err) {
    console.error('check-user failed:', err)
  }
  if (!ok) onFailure?.()
  return ok
}

export interface BootstrapErrorTexts {
  title: string
  message: string
  retry: string
}

/**
 * Sostituisce il loader con un messaggio d'errore e un pulsante di retry. Vue non è ancora
 * montato, quindi si usa il DOM puro (textContent: nessuna interpretazione di HTML).
 */
export function renderBootstrapError(
  doc: Document,
  texts: BootstrapErrorTexts,
  reload: () => void
): void {
  const root = doc.getElementById('app-loader')
  if (!root) return

  root.setAttribute('role', 'alert')
  root.setAttribute('aria-live', 'assertive')
  root.replaceChildren()

  const title = doc.createElement('h1')
  title.textContent = texts.title
  title.style.cssText = 'margin:0;font-size:1.125rem;font-weight:600;text-align:center'

  const message = doc.createElement('p')
  message.textContent = texts.message
  message.style.cssText = 'margin:0;max-width:24rem;text-align:center;font-size:0.875rem'

  const button = doc.createElement('button')
  button.type = 'button'
  button.textContent = texts.retry
  button.style.cssText =
    'padding:0.5rem 1rem;border:0;border-radius:0.375rem;background:#15738a;color:#fff;cursor:pointer'
  button.addEventListener('click', reload)

  root.append(title, message, button)
}
